'use strict';

angular.module('schoolbushubApp')
.controller('ToastNotificationCtrl', function($scope, $mdToast) {
    $scope.closeToast = function() {
        $mdToast.hide();
    };
});
